var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightningIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.431 62.414",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lightning_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lightning_icon_svg__a",
    d: "M52.09 3.13a32.2 32.2 0 01-17.359 58.237M18.206 57.71a32.215 32.215 0 01-1.209-56.343M45.383 1.367H25.327l-5.088 26.619h8.225l-3.195 29.052h3.043l17.837-34.009h-8.388zM49.251 11.216a24.172 24.172 0 01-11.81 41.876M16.017 12.277a24.191 24.191 0 004.511 37.641"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightningIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lightning_icon.6bc678bab56e82b3c91ee4006c3b25d1.svg";